var map = {
	"./digital-art-competition_concept_character.jpg": "./app/assets/images/competitions/digital_art/categories/digital-art-competition_concept_character.jpg",
	"./digital-art-competition_concept_environment.jpg": "./app/assets/images/competitions/digital_art/categories/digital-art-competition_concept_environment.jpg",
	"./digital-art-competition_concept_object.jpg": "./app/assets/images/competitions/digital_art/categories/digital-art-competition_concept_object.jpg",
	"./digital-art-competition_illustration_character.jpg": "./app/assets/images/competitions/digital_art/categories/digital-art-competition_illustration_character.jpg",
	"./digital-art-competition_illustration_environment.jpg": "./app/assets/images/competitions/digital_art/categories/digital-art-competition_illustration_environment.jpg",
	"./digital-art-competition_illustration_object.jpg": "./app/assets/images/competitions/digital_art/categories/digital-art-competition_illustration_object.jpg",
	"./digital-art-competition_public_award.jpg": "./app/assets/images/competitions/digital_art/categories/digital-art-competition_public_award.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/assets/images/competitions/digital_art/categories sync recursive ^\\.\\/.*\\.jpg$";